import React, { useRef, useEffect } from 'react';

interface UserGuideVideoProps {
  src?: string;
}

const UserGuideVideo: React.FC<UserGuideVideoProps> = ({ src }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const guideVideoDiv = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Force controls to show on video elements
    const videoElements = document.getElementsByClassName('video-react-video');
    if (videoElements.length) {
      Array.from(videoElements).forEach(function (element) {
        if (element instanceof HTMLVideoElement) {
          element.controls = true;
        }
      });
    }
  }, []);

  return (
    <div className="guideVideoDiv" ref={guideVideoDiv}>
      <video
        ref={videoRef}
        autoPlay
        muted
        controls
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          border: '1.59px solid #D1D1D1',
          borderRadius: '15.95px'
        }}
      >
        <source src={src} type="video/mp4" />
        {src && src.includes('.mp4') && (
          <>
            <source src={src.replace('.mp4', '.webm')} type="video/webm" />
            <source src={src.replace('.mp4', '.ogg')} type="video/ogg" />
          </>
        )}
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default UserGuideVideo;
